<div class="m-b-24">
    <div class="flex gap-2.5">
        <span>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C19.9939 15.5203 15.5203 19.9939 10 20ZM9 13V15H11V13H9ZM9 5V11H11V5H9Z"
                    attr.fill="{{percentage <= 40 ? '#1EB12D' : percentage <= 70 ? '#F08922':'#E94444'}}" />
            </svg>
        </span>
        <span class="font-medium text-black">
            Daily Limit Warning
        </span>
    </div>
    <div class="m-t-12 flex gap-4 rounded-lg px-4 py-4"
        [ngClass]="percentage <= 40 ? 'bg-bg-color-green' : percentage <= 70 ? 'bg-bg-color-yellow':'bg-bg-color-red'">
        <div class="custom-progress-circle">
            <nz-progress [nzStrokeColor]="percentage <= 40 ? '#1EB12D' : percentage <= 70 ? '#F08922':'#E94444'"
                nzStrokeLinecap="square" nzStrokeWidth="20" [nzWidth]="84" nzType="circle"
                [nzPercent]="percentage"></nz-progress>
        </div>

        <div class="text-black self-center">
            <div class="font-bold"> Daily Limit: {{dailyWebTransactionLimit | majorAmount | currency:"₦"}} </div>
            <div>You have <span class="font-bold">{{remainingAmount | majorAmount | currency:"₦"}}</span> remaining to
                spend today. </div>
            <div class="font-medium text-primary cursor-pointer">
                <span *ngIf="!showEditTransferLimitModal"
                    nzTooltipTitle="Kindly reach out to your Business Relationship Manager to have your limits increased."
                    nzTooltipPlacement="bottom" nz-tooltip [nzTooltipColor]="'white'"
                    nzTooltipOverlayClassName="custom-tooltip-col" [nzTooltipTrigger]="isMobile ? 'click':'hover'">
                    Increase Limit?
                </span>
                <span *ngIf="showEditTransferLimitModal" (click)="createEditTansferLimitModal()">
                    Increase Limit?
                </span>
            </div>
        </div>
    </div>
</div>